(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accusize-product-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(section) {
      if (section.dataset.accuProductContentReady === 'true') return;

      var tabs = Array.prototype.slice.call(section.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('[role="tabpanel"]'));
      var accordions = Array.prototype.slice.call(section.querySelectorAll('.accu-product-content__accordion'));
      var desktop = window.matchMedia('(min-width: 700px)');

      if (!tabs.length || !panels.length) return;

      function updateHash(panelId) {
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + panelId);
        }
      }

      function activateTab(panelId, moveFocus, setHash) {
        tabs.forEach(function (tab) {
          var selected = tab.getAttribute('aria-controls') === panelId;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          if (selected && moveFocus) tab.focus();
        });

        panels.forEach(function (panel) {
          panel.hidden = panel.id !== panelId;
        });

        accordions.forEach(function (button) {
          button.setAttribute('aria-expanded', button.getAttribute('aria-controls') === panelId ? 'true' : 'false');
        });

        if (setHash) updateHash(panelId);
      }

      function toggleAccordion(button) {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        var expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        panel.hidden = expanded;
        if (!expanded) updateHash(panel.id);
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activateTab(tab.getAttribute('aria-controls'), false, true);
        });

        tab.addEventListener('keydown', function (event) {
          var nextIndex = index;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === index && !['Home', 'End'].includes(event.key)) return;

          event.preventDefault();
          activateTab(tabs[nextIndex].getAttribute('aria-controls'), true, true);
        });
      });

      accordions.forEach(function (button) {
        button.addEventListener('click', function () {
          toggleAccordion(button);
        });
      });

      function applyViewport() {
        if (desktop.matches) {
          var selected = tabs.filter(function (tab) {
            return tab.getAttribute('aria-selected') === 'true';
          })[0] || tabs[0];
          activateTab(selected.getAttribute('aria-controls'), false, false);
        }
      }

      var hashPanel = panels.filter(function (panel) {
        return '#' + panel.id === window.location.hash;
      })[0];

      if (hashPanel) {
        if (desktop.matches) {
          activateTab(hashPanel.id, false, false);
        } else {
          var hashButton = accordions.filter(function (button) {
            return button.getAttribute('aria-controls') === hashPanel.id;
          })[0];
          if (hashButton) {
            accordions.forEach(function (button) {
              var selected = button === hashButton;
              button.setAttribute('aria-expanded', selected ? 'true' : 'false');
              var controlledPanel = section.querySelector('#' + button.getAttribute('aria-controls'));
              if (controlledPanel) controlledPanel.hidden = !selected;
            });
          }
        }
      } else {
        applyViewport();
      }

      if (desktop.addEventListener) desktop.addEventListener('change', applyViewport);
      else desktop.addListener(applyViewport);

      section.dataset.accuProductContentReady = 'true';
    }

    function boot(root) {
      var sections = root.querySelectorAll ? root.querySelectorAll('[data-accu-product-content]') : [];
      Array.prototype.forEach.call(sections, setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
